export default [
    {
      path: '/',
      component: () => import('@/views/Home.vue'),
    },
    {
      path: '/residential',
      component: () => import('@/views/Residential.vue'),
    },
    {
      path: '/commercial',
      component: () => import('@/views/Commercial.vue'),
    },
    {
      path: '/projects',
      component: () => import('@/views/Projects.vue'),
    },
    {
      path: '/contact',
      component: () => import('@/views/About.vue'),
    },
]